module.exports = __webpack_public_path__ + "img/Y7.ae297bdc.png";